import de from "@/assets/lang/de/index";
import german from "@/assets/lang/de/index";
import english from "@/assets/lang/en-GB";
import spanish from "@/assets/lang/es";
import italian from "@/assets/lang/it";
import french from "@/assets/lang/fr";
import netherland from "@/assets/lang/nl";
import greek from "@/assets/lang/el";
import romanian from "@/assets/lang/ro";
import tuerkiye from "@/assets/lang/tr";
import { UnionToIntersection } from "@/types/helper";

export type LanguageSchema = typeof de

// console.log(JSON.stringify(de))

export const messages = {
    de: german,
    en: english,
    es: spanish,
    it: italian,
    fr: french,
    nl: netherland,
    el: greek,
    ro: romanian,
    tr: tuerkiye
} as const

type keys = keyof typeof messages
export type MessageSchema = UnionToIntersection<typeof messages[keys]>
